
  import lottie from 'lottie-web';

  export default {
    props: {
      animation: {
        type: Object,
        required: true
      }
    },
    computed: {
      options () {
        return {
          animationData: this.animation,
          height: null,
          width: null
        };
      }
    },
    mounted () {
      this.anim = lottie.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: 'svg',
        loop: this.options.loop !== false,
        autoplay: this.options.autoplay !== false,
        animationData: this.options.animationData,
        rendererSettings: this.options.rendererSettings
      }
      );
      this.$emit('animCreated', this.anim);
    }
  };
